<div [ngClass]="{'cdk-overlay-dark-backdrop': isCollapsed}" class="dtc-case-custom" (click)="handleClose(false)"></div>
<div class="app_sideDrawer-add-protus uni-app-sidedrawer-add-protus" [class]="!isCollapsed ? 'collapsed' : ''">
  <div class="box uni-filter-header-bg">
    <div *ngIf="formType === 'newProtus'">Add {{ translatedText }}</div>
    <div *ngIf="formType === 'reoccurence'">Report Reoccurrence</div>
    <div (click)="handleClose(false)" class="cursor">X</div>
  </div>
    <div class="step-details" *ngIf="currentStep === 0 && formType === 'newProtus'">
      <div class="protus-header">
        Step 1/2 - Details
      </div>
      <form [formGroup]="addProtusFormFirst" class="protus-form">
        <div class="d-grid grid-display-colum gap20 margin-18">

          <div class="mt-3">
            <app-virtual-scroll-search-dropdown [isLoader]="isLoaderProjectName" [options]="projectsNameList"
              [formLabel]="'Project Name*'" [selectedOption]="getSelectedOption('projectsName')"
              (valueChange)="onVirtualScrollValueSelection('projectName', $event)"></app-virtual-scroll-search-dropdown>
          </div>
          <div class="mt-3">
            <app-virtual-scroll-search-dropdown [options]="trackingProjectsList"
              [addOption]="this.getAddOptionRequiredFlag('trackingProjectsList')" [formLabel]="'Tracking Projects*'"
              [selectedOption]="getSelectedOption('subProject')"
              (valueChange)="onVirtualScrollValueSelection('subProject', $event)"
              (optionAdditionOrDeletion)="updateConfiguration($event, 'trackingProjectsList')"></app-virtual-scroll-search-dropdown>
          </div>
        </div>

        <div class="protus-header">
          Vehicle Details
        </div>
        <div class="make-responsive-vehicle-details margin-18">
          <mat-form-field appearance="outline" class="mt-3" *ngIf="pageType !== 'addNewProtus'">
            <mat-label>Chassis No</mat-label>
            <input matInput formControlName="Chassis No">
          </mat-form-field>
          <app-virtual-scroll-search-dropdown *ngIf="pageType === 'addNewProtus'" class="mt-3" [isLoader]="isLoderChassisNo" [options]="chassisNumbers" [formLabel]="'Chassis No*'"
              [selectedOption]="getSelectedOption('Chassis No')"
              (valueChange)="onVirtualScrollValueSelection('Chassis No', $event)"></app-virtual-scroll-search-dropdown>
          <mat-form-field appearance="outline" class="mt-3">
            <mat-label>Vehicle Name</mat-label>
            <input matInput formControlName="Vehicle Name">
          </mat-form-field>

          <div>
            <app-virtual-scroll-search-dropdown [isLoader]="isLoaderModelNo" [options]="modelsList"
              [formLabel]="'Model No*'" [selectedOption]="getSelectedOption('modelNo')"
              (valueChange)="onVirtualScrollValueSelection('modelId', $event)"></app-virtual-scroll-search-dropdown>
          </div>

          <mat-form-field appearance="outline">
            <mat-label>Wheel Base</mat-label>
            <input matInput formControlName="Incident Related WheelBase">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Build Type</mat-label>
            <input matInput formControlName="Release Build">
          </mat-form-field>
          <mat-form-field appearance="outline">
            <mat-label>Build No</mat-label>
            <input matInput formControlName="Build Number">
          </mat-form-field>
        </div>
      </form>

      <div class="button-set">
        <button class="cancel" (click)="handleClose(false)">Cancel</button>
        <button class="select" (click)="goToNext()"
          [disabled]="addProtusFormFirst?.invalid || modelIds?.invalid || projectId?.invalid">Next</button>
      </div>
    </div>

    <div class="step-details" *ngIf="currentStep === 1 && formType === 'newProtus'">
      <div class="protus-header">
        Step 2/2 - Incident Details
      </div>
      <form [formGroup]="addProtusFormSecond" class="protus-form">
        <div class="make-responsive-vehicle-details margin-18">
          <mat-form-field appearance="outline" class="mt-3" *ngIf="pageType !== 'addNewProtus'">
            <mat-label>Incident Date</mat-label>
            <input matInput formControlName="Incident Date">
          </mat-form-field>
          <mat-form-field appearance="outline" class="mt-3" *ngIf="pageType === 'addNewProtus'">
            <mat-label>Incident Date</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="Incident Date" [max]="maxDate">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
          </mat-form-field>
          <div class="mt-3">
            <app-virtual-scroll-search-dropdown [options]="ncTypeList"
              [addOption]="this.getAddOptionRequiredFlag('ncType')" [formLabel]="'NC Type*'"
              [selectedOption]="getSelectedOption('NCType')"
              (valueChange)="onVirtualScrollValueSelection('NCType', $event)"
              (optionAdditionOrDeletion)="updateConfiguration($event, 'ncType')"></app-virtual-scroll-search-dropdown>
          </div>
          <mat-form-field appearance="outline" *ngIf="faultPoint">
            <mat-label>Fault Point</mat-label>
            <input matInput formControlName="Fault Point">
          </mat-form-field>

          <mat-form-field appearance="outline" *ngIf="!faultPoint">
            <mat-label>Fault Point</mat-label>
            <mat-select [disableOptionCentering]="true" formControlName="Fault Point">
              <mat-option *ngFor="let item of faultPointMapping" [value]="item?.value">
                {{ item?.severity | titlecase }} - {{ item?.value }}</mat-option>
            </mat-select>
          </mat-form-field>

          <div>
            <app-virtual-scroll-search-dropdown [options]="affectedAggregatesList"
              [addOption]="this.getAddOptionRequiredFlag('affectedAggregates')" [formLabel]="'Affected Aggregates*'"
              [selectedOption]="getSelectedOption('VECV_AggregateDetails')"
              (valueChange)="onVirtualScrollValueSelection('VECV_AggregateDetails', $event)"
              (optionAdditionOrDeletion)="updateConfiguration($event, 'affectedAggregates')"></app-virtual-scroll-search-dropdown>
          </div>
          <mat-form-field appearance="outline">
            <mat-label>Part No</mat-label>
            <input matInput formControlName="Part Name">
          </mat-form-field>
          <div>
            <app-virtual-scroll-search-dropdown [options]="testTypeList"
              [addOption]="this.getAddOptionRequiredFlag('testType')" [formLabel]="'Test Type*'"
              [selectedOption]="getSelectedOption('testType')"
              (valueChange)="onVirtualScrollValueSelection('testType', $event)"
              (optionAdditionOrDeletion)="updateConfiguration($event, 'testType')"></app-virtual-scroll-search-dropdown>
          </div>

          <div>
            <app-virtual-scroll-search-dropdown [options]="testObjectTypeList"
              [addOption]="this.getAddOptionRequiredFlag('testObjectType')" [formLabel]="'Test Object Type*'"
              [selectedOption]="getSelectedOption('testObjectType')"
              (valueChange)="onVirtualScrollValueSelection('testObjectType', $event)"
              (optionAdditionOrDeletion)="updateConfiguration($event, 'testObjectType')"></app-virtual-scroll-search-dropdown>
          </div>

          <div>
            <app-virtual-scroll-search-dropdown [options]="incidentCategoryList"
              [addOption]="this.getAddOptionRequiredFlag('incidentCategory')" [formLabel]="'Incident Category*'"
              [selectedOption]="getSelectedOption('incidentCategory')"
              (valueChange)="onVirtualScrollValueSelection('incidentCategory', $event)"
              (optionAdditionOrDeletion)="updateConfiguration($event, 'incidentCategory')"></app-virtual-scroll-search-dropdown>
          </div>
        </div>
        <div class="make-responsive-vehicle-details margin-18">
          <div>
            <div class="d-flex gap3 align-items-center" *ngIf="pageType !== 'addNewProtus'">
              <img src="../../../../assets/images/protus-download.svg" matTooltip="Download data" alt="Download"
                class="m-40r cursor" (click)="exportTelemetryData()">
              <div class="field-label cursor" (click)="exportTelemetryData()">Download Telemetry Data</div>
            </div>
            <div class="add-protus-file" [ngClass]="{'mt-23': pageType === 'addNewProtus'}">
              <div class="file-drop-wrapper">
                <span>
                  <img src="../../../../assets/images/incident-report-upload-icon.svg" matTooltip="Upload data"
                    (click)="fileUpload?.click()" alt="Upload" class="cursor">
                </span>
                <span width="100%" class="upload-text d-flex gap-1" [ngClass]="{'width-18' : file?.name?.length > 30}"
                  *ngIf="file!==null">
                  <a class="file-name" [matTooltip]="file?.name">{{file?.name}}</a>
                  <em class="fas fa-trash-alt cursor" (click)="file=null;fileUpload.value = ''"></em>
                </span>
                <input id="uploadCaptureInputFile" #fileUpload type="file" style="display: none;"
                  (change)="uploadFile($event)" [accept]="acceptTypes">
                <span class="upload-link" (click)="fileUpload?.click()" *ngIf="file === null" style="width: 100%;">
                  <a class="cursor ml-2 upload-incident">Upload Incident Report*</a>
                  <a class="cursor ml-2 upload-incident">Max size limit : 100MB*</a>
                  <span class="mb-0 d-flex justify-content-center upload-text-info"
                    matTooltip="{{ fileTypes.join(', ') }}" matTooltipPosition="above">
                    <ng-container *ngFor="let type of fileTypes; let last = last">
                      <span>{{ type }}<span *ngIf="!last">, </span></span>
                    </ng-container>
                  </span>
                </span>
              </div>
            </div>
          </div>
          <div class="mt-3">
            <div class="field-label">Is Correct Process Used*</div>
            <div class="d-grid gap-10">
              <mat-form-field appearance="outline">
                <mat-label>Select</mat-label>
                <mat-select [disableOptionCentering]="true" formControlName="Correct Process Used">
                  <mat-option *ngFor="let item of correctProcessUsedList" [value]="item?.value">
                    {{item?.name}}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Process Remarks</mat-label>
                <textarea matInput formControlName="Process Remarks"></textarea>
              </mat-form-field>
            </div>
          </div>
          <div>
            <mat-form-field appearance="outline">
              <mat-label>Description</mat-label>
              <textarea matInput [formControl]="description"></textarea>
            </mat-form-field>
          </div>
          <div class="mt-2">
            <div class="field-label">Is Tool & Part verification done/EBOM part used*</div>
            <div class="d-grid gap-10">
              <mat-form-field appearance="outline">
                <mat-label>Select</mat-label>
                <mat-select [disableOptionCentering]="true" formControlName="Tool & Part Verification Done">
                  <mat-option *ngFor="let item of toolPartVerificationList" [value]="item?.value">
                    {{item?.name}}</mat-option>
                </mat-select>
              </mat-form-field>
              <mat-form-field appearance="outline">
                <mat-label>Verification Remarks</mat-label>
                <textarea matInput formControlName="Verification Remarks"></textarea>
              </mat-form-field>
            </div>
          </div>
        </div>
      </form>
      <div class="button-set">
        <button class="cancel" (click)="goToPrevious()">Back</button>
        <button class="cancel" (click)="handleClose(false)">Cancel</button>
        <button class="select" [disabled]="addProtusFormSecond?.invalid || description?.invalid || file === null"
          (click)="addProtus()">Submit</button>
      </div>
    </div>

  <div *ngIf="formType === 'reoccurence'" class="step-details">
    <form [formGroup]="reportReoccurenceForm" class="reoccurence-form mt-3">
      <div class="margin-18">
      <mat-form-field appearance="outline" class="mt-3">
        <mat-label>Protus</mat-label>
        <mat-select [disableOptionCentering]="true" formControlName="protusId"
          (selectionChange)="onProtusSelection($event)">
          <mat-option *ngFor="let item of protusList" [value]="item?.value">
            {{ item?.name }}</mat-option>
        </mat-select>
      </mat-form-field>
      <div class="make-responsive-vehicle-details mt-3" *ngIf="this.reportReoccurenceForm?.get('protusId')?.value">
        <mat-form-field class="field" appearance="outline">
          <mat-label>Build type</mat-label>
          <input matInput formControlName="buildType">
        </mat-form-field>
        <mat-form-field class="field" appearance="outline">
          <mat-label>Build Number</mat-label>
          <input matInput formControlName="buildNumber">
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>Remarks</mat-label>
          <mat-select [disableOptionCentering]="true" formControlName="remarks">
            <mat-option *ngFor="let item of remarksList" [value]="item?.value">
              {{ item?.name }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="field" appearance="outline">
          <mat-label>Reoccurrence Info</mat-label>
          <input matInput formControlName="reoccuranceInfo">
        </mat-form-field>
        <mat-form-field class="field" appearance="outline">
          <mat-label>Reoccurrence Vehicle No</mat-label>
          <input matInput formControlName="reoccurenceVehicalNumber">
        </mat-form-field>
        <div></div>
        <div class="add-protus-file">
          <div class="file-drop-wrapper">
            <span>
              <img src="../../../../assets/images/incident-report-upload-icon.svg" matTooltip="Upload data"
                (click)="fileUpload?.click()" alt="Upload" class="cursor">
            </span>
            <span width="100%" class="upload-text d-flex gap-1" [ngClass]="{'width-18' : file?.name?.length > 30}"
              *ngIf="file!==null">
              <a class="file-name" [matTooltip]="file?.name">{{file?.name}}</a>
              <em class="fas fa-trash-alt cursor" (click)="file=null;fileUpload.value = ''"></em>
            </span>
            <input id="uploadCaptureInputFile" #fileUpload type="file" style="display: none;"
              (change)="uploadFile($event)" [accept]="acceptTypes">
            <span class="upload-link" (click)="fileUpload?.click()" *ngIf="file === null" style="width: 100%;">
              <a class="cursor ml-2 upload-incident">Upload Incident Report*</a>
              <a class="cursor ml-2 upload-incident">Max size limit : 100MB*</a>
              <span class="mb-0 d-flex justify-content-center upload-text-info" matTooltip="{{ fileTypes.join(', ') }}"
                matTooltipPosition="above">
                <ng-container *ngFor="let type of fileTypes; let last = last">
                  <span>{{ type }}<span *ngIf="!last">, </span></span>
                </ng-container>
              </span>
            </span>
          </div>
        </div>
      </div>
      </div>
    </form>
    <div class="button-set">
      <button class="cancel" (click)="handleClose(false)">Cancel</button>
      <button class="select" (click)="attachToProtus()"
        [disabled]="reportReoccurenceForm?.invalid || file === null">Attach to Protus</button>
    </div>
  </div>
</div>

<ng-template #errorDialog let-data>
  <h2 mat-dialog-title>Invalid file type</h2>
  <mat-dialog-content>{{ data }}</mat-dialog-content>
  <mat-dialog-actions align="end">
    <button mat-button mat-dialog-close color="primary">OK</button>
  </mat-dialog-actions>
</ng-template>